import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import css from './SectionCta.module.css';
import { NamedLink } from '../../../components';
import { t } from '../../../util/messages';

/**
 * Closing call to action.
 *
 * A full-bleed dark band with ambient light — the last strong moment before
 * the contact form. The previous decorative illustration was dropped: it
 * carried blue and orange shapes that sit outside the palette, and the band
 * reads stronger as type plus light.
 */
const SectionCta = ({ rootClassName, className }) => {
  const classes = classNames(rootClassName || css.root, className);

  return (
    <section id="request-quote" className={classes} aria-label="Start a project">
      <div className={css.aura} aria-hidden="true" />
      <div className={css.content}>
        <div className={css.copy}>
          <span className={css.tag} data-reveal>
            <i aria-hidden="true" />
            {t('SectionCta.eyebrow')}
          </span>
          <h2 className={css.title} data-reveal data-reveal-delay="70">
            {t('SectionCta.heading')}
          </h2>
          <p className={css.description} data-reveal data-reveal-delay="140">
            {t('SectionCta.description')}
          </p>
        </div>

        <div className={css.actions} data-reveal data-reveal-delay="140">
          <NamedLink
            className={css.action}
            name="LandingPage"
            title={t('SectionCta.cta')}
            to={{ hash: '#contact-us' }}
          >
            {t('SectionCta.cta')}
            <svg
              className={css.arrow}
              width="15"
              height="11"
              viewBox="0 0 15 11"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M9.5 1L14 5.5 9.5 10M14 5.5H0"
                stroke="currentColor"
                strokeWidth="1.7"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </NamedLink>
        </div>
      </div>
    </section>
  );
};

SectionCta.propTypes = {
  rootClassName: string,
  className: string,
};

export default React.memo(SectionCta);
